export default "__VITE_PUBLIC_ASSET__7e91815a__"